// LUMINA · OfferingDetailPage.jsx
// 供养项目详情页 — 大图 + 图库 + 供养表单 / 圆满功德芳名

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API, GD, GDL, GDH, BG, TXT, TXT2 } from './constants';

const RATES = { USD: 1.37, CNY: 0.19 };

export default function OfferingDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [target,     setTarget]     = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [error,      setError]      = useState("");
  const [lightbox,   setLightbox]   = useState(null);
  const [form,       setForm]       = useState({ donor_name: "", amount_cad: "", currency: "CAD", original_amount: "", dedication_name: "", dedication_type: "", message: "", payment_method: "etransfer", received_by: "" });
  const [submitted,  setSubmitted]  = useState(false);
  const [offerErr,   setOfferErr]   = useState("");
  useEffect(() => {
    fetch(`${API}/vajra/offerings/targets/${id}`)
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(d => { setTarget(d); setLoading(false); })
      .catch(() => { setError("供养对象不存在"); setLoading(false); });
  }, [id]);

  const submitOffer = async (e) => {
    e.preventDefault();
    if (!form.donor_name.trim()) { setOfferErr("请填写供养者姓名"); return; }
    const cadAmt = form.currency === "CAD"
      ? (parseFloat(form.amount_cad) || 0)
      : (parseFloat(form.original_amount) || 0) * (RATES[form.currency] || 1);
    const displayAmt = form.currency === "CAD"
      ? (parseFloat(form.amount_cad) || 0)
      : (parseFloat(form.original_amount) || 0);
    if (cadAmt <= 0) { setOfferErr("请输入金额"); return; }
    const body = {
      target_id: parseInt(id), donor_name: form.donor_name,
      amount_cad: Math.round(cadAmt * 100) / 100,
      currency: form.currency,
      original_amount: form.currency === "CAD" ? null : Math.round(displayAmt * 100) / 100,
      is_merit_seat: cadAmt >= 50,
      dedication_name: form.dedication_name || null,
      dedication_type: form.dedication_type || null,
      message: form.message || null,
      payment_method: form.payment_method,
      received_by: form.payment_method === "cash" ? (form.received_by || "Jack") : null,
    };
    const token = localStorage.getItem("vajra_token");
    const h = token ? { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" }
                    : { "Content-Type": "application/json" };
    const r = await fetch(`${API}/vajra/offerings`, { method: "POST", headers: h, body: JSON.stringify(body) });
    if (r.ok) { setSubmitted(true); setOfferErr(""); }
    else { const d = await r.json().catch(() => {}); setOfferErr(d?.detail || "提交失败"); }
  };

  if (loading) return <div style={{minHeight:"100vh",background:BG,display:"flex",alignItems:"center",justifyContent:"center",color:TXT2}}>加载中...</div>;
  if (error || !target) return (
    <div style={{minHeight:"100vh",background:BG,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:16}}>
      <div style={{fontSize:18,color:TXT2}}>{error || "未找到"}</div>
      <button onClick={()=>navigate('/vajra')} style={{color:GD,background:"none",border:`1px solid ${GD}`,borderRadius:8,padding:"6px 20px",cursor:"pointer"}}>← 返回首页</button>
    </div>
  );

  const photos = [target.photo_url, ...(Array.isArray(target.gallery_images) ? target.gallery_images : [])].filter(Boolean);
  const amountPresets = target.currency === "CNY" ? [50, 100, 200, 500, 1000] : [5, 10, 20, 50, 108];
  const meritProject = target.linked_merit_project;
  const donors = meritProject?.donor_list || [];
  const receipts = meritProject?.receipt_images || [];

  return (
    <div style={{minHeight:"100vh",background:BG,fontFamily:"'Noto Serif SC','Noto Serif',serif",color:TXT}}>

      {/* Lightbox */}
      {lightbox && (
        <div onClick={()=>setLightbox(null)} style={{position:"fixed",inset:0,zIndex:2000,background:"rgba(0,0,0,0.85)",display:"flex",alignItems:"center",justifyContent:"center",cursor:"zoom-out",padding:20}}>
          <img src={lightbox} alt="" style={{maxWidth:"90vw",maxHeight:"85vh",objectFit:"contain",borderRadius:8}} />
          <button onClick={()=>setLightbox(null)} style={{position:"absolute",top:20,right:20,background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",fontSize:28,width:44,height:44,borderRadius:"50%",cursor:"pointer",lineHeight:"44px"}}>✕</button>
        </div>
      )}

      {/* Back nav */}
      <div style={{padding:"14px 24px",borderBottom:"1px solid rgba(212,175,55,0.2)"}}>
        <button onClick={()=>navigate('/vajra')} style={{background:"none",border:"none",color:GD,fontSize:13,cursor:"pointer",padding:0,fontFamily:"inherit"}}>
          ← 返回如意宝金刚社群
        </button>
      </div>

      <div style={{maxWidth:640,margin:"0 auto",padding:"0 20px 40px"}}>

        {/* Hero image */}
        {target.photo_url && (
          <img src={target.photo_url} alt={target.name_zh}
            onClick={()=>setLightbox(target.photo_url)}
            style={{width:"100%",maxHeight:380,objectFit:"cover",borderRadius:14,marginTop:24,cursor:"zoom-in"}}
            onError={e=>{e.currentTarget.style.display="none"}}/>
        )}

        {/* Title + completed badge */}
        <div style={{display:"flex",alignItems:"center",gap:10,marginTop:24,marginBottom:4}}>
          <h1 style={{fontSize:22,color:GD,fontWeight:600,margin:0,fontFamily:"'Noto Serif SC',serif"}}>
            🪷 {target.name_zh}
          </h1>
          {meritProject && (
            <span style={{
              fontSize:10,padding:"3px 12px",borderRadius:10,
              background:"linear-gradient(135deg,#D4AF37,#B8860B)",color:"#fff",
              letterSpacing:1,fontWeight:600,whiteSpace:"nowrap",
            }}>🟡 已圆满</span>
          )}
        </div>
        {target.name_en && <div style={{fontSize:12,color:TXT2,marginBottom:16}}>{target.name_en}</div>}

        {/* Description */}
        {target.description && (
          <div style={{fontSize:13,color:TXT2,lineHeight:1.9,marginBottom:20}}>
            {target.description}
          </div>
        )}

        {/* Gallery */}
        {photos.length > 1 && (
          <div style={{marginBottom:24}}>
            <div style={{fontSize:11,color:GDL,letterSpacing:1,marginBottom:8,textTransform:"uppercase"}}>图片</div>
            <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:4}}>
              {photos.map((url,i)=>(
                <img key={i} src={url} alt=""
                  onClick={()=>setLightbox(url)}
                  style={{width:160,height:120,objectFit:"cover",borderRadius:8,flexShrink:0,cursor:"zoom-in",border:"2px solid transparent"}}
                  onError={e=>{e.currentTarget.style.display="none"}}/>
              ))}
            </div>
          </div>
        )}

        {/* Divider */}
        <div style={{height:1,background:"linear-gradient(90deg,transparent,rgba(184,134,11,0.3),transparent)",marginBottom:24}}/>

        {/* ── Completed Merit Project: 功德芳名 ── */}
        {meritProject ? (
          <div style={{
            background:"#ffffff",borderRadius:12,
            border:"1px solid rgba(212,175,55,0.15)",padding:"16px 18px",
            boxShadow:"0 2px 8px rgba(0,0,0,0.06)",
          }}>
            {/* Merit project header */}
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
              <span style={{fontSize:18}}>🛕</span>
              <div style={{flex:1}}>
                <div style={{fontSize:14,fontWeight:600,color:TXT,letterSpacing:".5px"}}>
                  {meritProject.title_zh}
                </div>
                {meritProject.temple_name && (
                  <div style={{fontSize:11,color:GDL}}>{meritProject.temple_name}</div>
                )}
              </div>
            </div>

            {/* Merit project description */}
            {meritProject.description_zh && (
              <div style={{fontSize:12,color:TXT2,lineHeight:1.8,marginBottom:12}}>
                {meritProject.description_zh}
              </div>
            )}

            {/* Completion info */}
            <div style={{display:"flex",gap:16,marginBottom:10,fontSize:12}}>
              {meritProject.completed_date && (
                <span style={{color:TXT2}}>
                  📅 圆满日期：{meritProject.completed_date}
                </span>
              )}
              {meritProject.total_donors > 0 && (
                <span style={{color:GD,fontWeight:600}}>
                  🪷 {meritProject.total_donors} 位功德主
                </span>
              )}
            </div>

            {/* Donor list — always visible */}
            {donors.length > 0 && (
              <div style={{
                marginTop: 8, padding: "10px 14px",
                background: "rgba(212,175,55,0.06)", borderRadius: 8,
                border: "1px solid rgba(212,175,55,0.15)", marginBottom: 10,
              }}>
                {donors.map((d, i) => (
                  <div key={i} style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "4px 0", borderBottom: i < donors.length - 1 ? "1px solid rgba(212,175,55,0.08)" : "none",
                    fontSize: 12, color: TXT,
                  }}>
                    <span>
                      {d.item && <span style={{ color: GDL, marginRight: 6 }}>{d.item}</span>}
                      <strong>{(d.name || '').trim().split(/\s+/).length > 1
                        ? d.name.trim().split(/\s+/).pop()
                        : ((d.name || '')[0] || '')}</strong>
                      {(d.name || '').length > 1 && <span style={{ fontSize: 10, color: TXT2, marginLeft: 2 }}>◌</span>}
                    </span>
                    {d.dedication && (
                      <span style={{ fontSize: 10, color: TXT2, fontStyle: "italic" }}>
                        {d.dedication}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Receipt images */}
            {receipts.length > 0 && (
              <div>
                <div style={{fontSize:11,color:TXT2,marginBottom:6,letterSpacing:".5px"}}>
                  🧾 寺庙收据
                </div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {receipts.map((url, i) => (
                    <img key={i} src={url} alt={`收据 ${i+1}`}
                      onClick={()=>setLightbox(url)}
                      style={{
                        width:80,height:60,objectFit:"cover",borderRadius:6,
                        cursor:"zoom-in",border:"1px solid rgba(212,175,55,0.2)",
                      }}
                      onError={e=>{e.currentTarget.style.display="none"}}/>
                  ))}
                </div>
              </div>
            )}
          </div>
        ) : (
          /* ── Active Offering: 随喜供养表单 ── */
          submitted ? (
            <div style={{textAlign:"center",padding:"30px 0"}}>
              <div style={{fontSize:32,marginBottom:12}}>🙏</div>
              <div style={{fontSize:15,color:GD,marginBottom:6}}>供养已记录</div>
              <div style={{fontSize:12,color:TXT2,marginBottom:12}}>感恩您的发心！</div>
              <div style={{fontSize:11,color:TXT2,lineHeight:1.8}}>
                {form.payment_method==="etransfer"&&"请 E-Transfer 至 canada.btf@gmail.com"}
                {form.payment_method==="paypal"&&"请通过 PayPal 转至 canada.btf@gmail.com"}
                {form.payment_method==="wechat"&&"请微信转账至 jxuabc"}
                {form.payment_method==="cash"&&"请将现金交予收款人"}
              </div>
              <button onClick={()=>setSubmitted(false)} style={{marginTop:16,padding:"8px 24px",borderRadius:8,border:"1px solid rgba(139,105,20,0.3)",background:"rgba(139,105,20,0.06)",color:GD,fontSize:12,cursor:"pointer"}}>继续供养</button>
            </div>
          ) : (
            <form onSubmit={submitOffer}>
              <div style={{fontSize:14,color:GD,fontWeight:600,marginBottom:16}}>随喜供养</div>

              {/* Currency */}
              <div style={{marginBottom:14}}>
                <div style={{fontSize:11,color:"#999",marginBottom:6}}>币种</div>
                <div style={{display:"flex",gap:8}}>
                  {["CAD","USD","CNY"].map(c=>(
                    <button key={c} type="button" onClick={()=>setForm(f=>({...f,currency:c,amount_cad:"",original_amount:""}))}
                      style={{padding:"6px 16px",borderRadius:7,fontSize:12,cursor:"pointer",
                        background:form.currency===c?GDH:"transparent",
                        border:`1px solid ${form.currency===c?GDH:"rgba(212,175,55,0.30)"}`,
                        color:form.currency===c?"#fff":GD}}>{c}</button>
                  ))}
                </div>
              </div>

              {/* Amount */}
              <div style={{marginBottom:14}}>
                <div style={{fontSize:11,color:"#999",marginBottom:6}}>金额 ({form.currency})</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
                  {amountPresets.map(a=>(
                    <button key={a} type="button"
                      onClick={()=>setForm(f=>form.currency==="CAD"?{...f,amount_cad:String(a)}: {...f,original_amount:String(a)})}
                      style={{padding:"4px 12px",borderRadius:6,fontSize:12,cursor:"pointer",
                        background:form.currency==="CAD"
                          ? (parseFloat(form.amount_cad)===a?GD:"transparent")
                          : (parseFloat(form.original_amount)===a?GD:"transparent"),
                        border:`1px solid ${(form.currency==="CAD"&&parseFloat(form.amount_cad)===a)||(form.currency!=="CAD"&&parseFloat(form.original_amount)===a)?GD:"rgba(139,105,20,0.3)"}`,
                        color:(form.currency==="CAD"&&parseFloat(form.amount_cad)===a)||(form.currency!=="CAD"&&parseFloat(form.original_amount)===a)?"#fff":GD}}>
                      {form.currency==="CNY"?"¥":"$"}{a}
                    </button>
                  ))}
                </div>
                <input type="number" step="any" min="0"
                  value={form.currency==="CAD"?form.amount_cad:form.original_amount}
                  onChange={e=>setForm(f=>form.currency==="CAD"?{...f,amount_cad:e.target.value}:{...f,original_amount:e.target.value})}
                  placeholder={form.currency==="CAD"?"$0.00":"0"}
                  style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(139,105,20,0.3)",borderRadius:7,fontSize:14,boxSizing:"border-box"}}/>
                {form.currency!=="CAD"&&form.original_amount&&(
                  <div style={{fontSize:10,color:TXT2,marginTop:4}}>
                    ≈ CAD {(parseFloat(form.original_amount)||0)*(RATES[form.currency]||1)} ({form.currency} {form.original_amount} × {RATES[form.currency]})
                  </div>
                )}
              </div>

              {/* Donor name */}
              <div style={{marginBottom:14}}>
                <div style={{fontSize:11,color:"#999",marginBottom:4}}>供养者姓名 <span style={{color:GD}}>*</span></div>
                <input value={form.donor_name} onChange={e=>setForm(f=>({...f,donor_name:e.target.value}))}
                  placeholder="您的法名或姓名" style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(139,105,20,0.3)",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
              </div>

              {/* Payment method */}
              <div style={{marginBottom:14}}>
                <div style={{fontSize:11,color:"#999",marginBottom:6}}>支付方式</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {[
                    {k:"etransfer",l:"E-Transfer"},
                    {k:"paypal",l:"PayPal"},
                    {k:"wechat",l:"微信"},
                    {k:"cash",l:"现金"},
                  ].map(p=>(
                    <button key={p.k} type="button" onClick={()=>setForm(f=>({...f,payment_method:p.k}))}
                      style={{padding:"5px 14px",borderRadius:7,fontSize:12,cursor:"pointer",
                        background:form.payment_method===p.k?GD:"transparent",
                        border:`1px solid ${form.payment_method===p.k?GD:"rgba(139,105,20,0.3)"}`,
                        color:form.payment_method===p.k?"#fff":GD}}>{p.l}</button>
                  ))}
                </div>
                {form.payment_method==="cash"&&(
                  <input value={form.received_by} onChange={e=>setForm(f=>({...f,received_by:e.target.value}))}
                    placeholder="收款人（默认 Jack）" style={{width:"100%",marginTop:8,padding:"8px 12px",border:"1px solid rgba(139,105,20,0.3)",borderRadius:7,fontSize:12,boxSizing:"border-box"}}/>
                )}
              </div>

              {/* Dedication */}
              <div style={{marginBottom:14}}>
                <div style={{fontSize:11,color:"#999",marginBottom:4}}>回向（选填）</div>
                <input value={form.dedication_name} onChange={e=>setForm(f=>({...f,dedication_name:e.target.value}))}
                  placeholder="回向对象姓名" style={{width:"100%",padding:"8px 12px",border:"1px solid rgba(139,105,20,0.3)",borderRadius:7,fontSize:12,boxSizing:"border-box",marginBottom:6}}/>
                <input value={form.dedication_type} onChange={e=>setForm(f=>({...f,dedication_type:e.target.value}))}
                  placeholder="回向类型（如：往生、祈福）" style={{width:"100%",padding:"8px 12px",border:"1px solid rgba(139,105,20,0.3)",borderRadius:7,fontSize:12,boxSizing:"border-box"}}/>
              </div>

              {/* Message */}
              <div style={{marginBottom:16}}>
                <div style={{fontSize:11,color:"#999",marginBottom:4}}>留言（选填）</div>
                <textarea value={form.message} onChange={e=>setForm(f=>({...f,message:e.target.value}))}
                  placeholder="给寺院的留言..." rows={2}
                  style={{width:"100%",padding:"8px 12px",border:"1px solid rgba(139,105,20,0.3)",borderRadius:7,fontSize:12,boxSizing:"border-box",resize:"vertical"}}/>
              </div>

              {/* Error */}
              {offerErr && <div style={{color:"#c0392b",fontSize:12,marginBottom:12}}>{offerErr}</div>}

              {/* Submit */}
              <button type="submit" style={{width:"100%",padding:"11px 0",borderRadius:9,
                background:`linear-gradient(135deg,${GD},#A07828)`,border:"none",color:"#fff",
                fontSize:14,fontWeight:600,cursor:"pointer",letterSpacing:2}}>
                🙏 确认供养
              </button>
            </form>
          )
        )}

      </div>
    </div>
  );
}
